import React, { useRef, useEffect } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import useAddressAutocomplete from '../../hooks/useAddressAutocomplete';

/**
 * Generic address autocomplete input.
 * onSelect(suggestion) receives the full AddressSuggestionDto object.
 */
const AddressAutocompleteInput = ({ onSelect, disabled = false }) => {
    const { query, setQuery, suggestions, isLoading, clear } = useAddressAutocomplete();
    const containerRef = useRef(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                clear();
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [clear]);

    const handleSelect = (suggestion) => {
        onSelect(suggestion);
        clear();
    };

    return (
        <div ref={containerRef} style={{ position: 'relative' }}>
            <div style={{ position: 'relative' }}>
                <Form.Control
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Busca una dirección para autocompletar..."
                    disabled={disabled}
                    className="form-control-lg"
                />
                {isLoading && (
                    <Spinner
                        animation="border"
                        size="sm"
                        style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)' }}
                    />
                )}
            </div>

            {suggestions.length > 0 && (
                <ul
                    className="list-group shadow"
                    style={{
                        position: 'absolute',
                        zIndex: 1050,
                        width: '100%',
                        maxHeight: 260,
                        overflowY: 'auto',
                        margin: 0,
                        padding: 0,
                    }}
                >
                    {suggestions.map((s, i) => (
                        <li
                            key={i}
                            className="list-group-item list-group-item-action"
                            style={{ cursor: 'pointer', fontSize: '0.9rem' }}
                            onMouseDown={() => handleSelect(s)}
                        >
                            {s.displayName}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AddressAutocompleteInput;
